export default "__VITE_ASSET__DFuleBBl__"